<template>
    <div id="bpmn-canvas"></div>
</template>

<script>
  import {OK} from 'http-status-codes'
  import BpmnNavigatedViewer from 'bpmn-js/dist/bpmn-navigated-viewer.production.min'

  export default {
    props: ['data'],
    async mounted () {
      const response = await this.$store.dispatch('camunda/fetchProcessDefinitionXml', this.data.id)

      if (OK !== response.status) {
        console.error('Error Fetching BPMN XML', JSON.stringify(response))
        return
      }

      const bpmnXML = this.$store.getters['camunda/processDefinitionXml']
      const viewer = new BpmnNavigatedViewer({ container: '#bpmn-canvas' })
      viewer.importXML(bpmnXML, function (err) {
        if (err) {
          console.error('Error Rendering BPMN XML', err)
        }
      })
    }
  }
</script>

<style scoped>
  #bpmn-canvas {
    height: calc(80vh);
    padding: 0;
    margin: 0;
  }
  .diagram-note {
    background-color: rgba(66, 180, 21, 0.7);
    color: white;
    border-radius: 5px;
    font-size: 12px;
    padding: 5px;
    min-height: 16px;
    width: 50px;
    text-align: center;
  }
  .needs-discussion:not(.djs-connection) .djs-visual > :nth-child(1) {
    stroke: rgba(66, 180, 21, 0.7) !important; /* color elements as red */
  }
</style>
